import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useBrandStore } from '@stores/brandStore';
import { AuthProvider } from '@components/auth/AuthProvider';
import { RequireNameModal } from '@components/common/RequireNameModal';
import { ToastContainer } from '@components/ui/Toast';
import { useAnalytics } from '@/hooks/useAnalytics';

// Auth Pages
import PhoneVerificationPage from '@pages/auth/PhoneVerification';
import OTPVerificationPage from '@pages/auth/OTPVerification';
import MagicLinkVerifyPage from '@pages/auth/MagicLinkVerify';

// Onboarding Pages
import WelcomePage from '@pages/onboarding/Welcome';
import OnboardingPage from '@pages/onboarding/Onboarding';
import LocationSetupPage from '@pages/onboarding/LocationSetup';

// Main Pages
import HomePage from '@pages/Home';
import PhoneCapturePage from '@pages/payout/PhoneCapture';

function App() {
  const { initializeBrand } = useBrandStore();
  useAnalytics();

  useEffect(() => {
    initializeBrand();
  }, [initializeBrand]);

  return (
    <AuthProvider>
      <RequireNameModal />
      <ToastContainer />
      <Routes>
        {/* Auth */}
        <Route path="/auth/phone" element={<PhoneVerificationPage />} />
        <Route path="/auth/verify-otp" element={<OTPVerificationPage />} />
        <Route path="/auth/:token" element={<MagicLinkVerifyPage />} />

        {/* Onboarding */}
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/location-setup" element={<LocationSetupPage />} />

        {/* Main App */}
        <Route path="/home/*" element={<HomePage />} />

        {/* Payout flow */}
        <Route path="/payout/phone" element={<PhoneCapturePage />} />

        {/* Redirect root to home or auth */}
        <Route path="/" element={<Navigate to="/home" replace />} />

        {/* Fallback — AuthProvider will redirect to correct page */}
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
